import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
 const Item2Modal = ({email: ema, i, desvinculedEmail}) => {
    let {email, numeroReportes} = ema;

    const handleDesvinculedEmail = () => {
        desvinculedEmail({email: ema});
    }

    return (
        <tr key={ema._id} >
            <th scope="row">{i + 1}</th>
            <td className="text-center">{email}</td>
            <td className="text-center">{numeroReportes}</td>
            <td className="text-center">
                <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip-top">Desvincular Correo</Tooltip>}>
                    <button type="button" 
                            className="btn btn-sm btn-danger"
                            onClick={handleDesvinculedEmail}>
                        <i className="bi bi-trash"/>
                    </button>
                </OverlayTrigger>
            </td>
        </tr>
    );
}
export default Item2Modal;
